// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Page not found`
};

const de_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Seite nicht gefunden`
};

const es_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Página no encontrada`
};

const fr_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Page introuvable`
};

const ja_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `ページが見つかりません`
};

const nl_notfoundheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Pagina niet gevonden`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "ja" | "nl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const notfoundheading2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.notfoundheading2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("notfoundheading2", locale)
	if (locale === "en") return en_notfoundheading2(inputs)
	if (locale === "de") return de_notfoundheading2(inputs)
	if (locale === "es") return es_notfoundheading2(inputs)
	if (locale === "fr") return fr_notfoundheading2(inputs)
	if (locale === "ja") return ja_notfoundheading2(inputs)
	return nl_notfoundheading2(inputs)
};
export { notfoundheading2 as "notFoundHeading" }